module.exports = __webpack_public_path__ + "img/54ne.e7013f38.svg";